<template>
  <b-container class="mb-4">
    <config-publisher
      ref="configPublisher"
      v-model="config"
      class="p-0"
      tool-name="Calendar Flip Configuration Tool"
      tool-icon-text="(╯°□°)╯︵ 📅"
      :config-name="configName"
      :can-edit="canScoreboardFlipEdit"
      :can-publish="canScoreboardFlipPublish"
      :is-form-valid="isValid">
      <b-card no-body>
        <b-tabs card>
          <b-tab title="Games">
            <h3>Scoreboard</h3>
            <flip-time
              v-if="config.scoreboard"
              id="scoreboard"
              ref="flipTimeScoreboard"
              v-model="config.scoreboard"
              @has-errors="handleScoreboardErrors" />
          </b-tab>
          <b-tab title="Seasons">
            <b-card header="Seasons Configuration">
              <b-form-group
                label="Current Season"
                :state="currentSeasonState"
                invalid-feedback="Please set the current season id">
                <b-form-input
                  v-model="config.currentSeasonId"
                  placeholder="Enter the current season"
                  required />
              </b-form-group>
            </b-card>
            <b-card
              v-for="(season, index) in config.supportedSeasons"
              :key="index"
              class="mt-3">
              <seasons
                v-if="config.supportedSeasons"
                ref="form"
                :season="season"
                @season-update="onSeasonUpdate" />
              <b-btn
                variant="link"
                size="sm"
                class="float-right text-danger pt-1 pr-0"
                @click.prevent="onRemoveSeasonRange(index)">
                Remove
              </b-btn>
            </b-card>
            <b-btn
              variant="primary"
              style="float: right"
              class="mt-3 mb-3"
              @click.prevent="onAddSeasonRange">
              Add Season Range
            </b-btn>
          </b-tab>
        </b-tabs>
      </b-card>
    </config-publisher>
  </b-container>
</template>

<script>
  import {mapGetters} from 'vuex'
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
  import FlipTime from "../components/CalendarConfiguration/FlipTime"
  import Seasons from "../components/CalendarConfiguration/Seasons"
  import ConfigPublisher from "@/components/ConfigPublisher"

  const DEFAULT_TIMEZONE = 'America/New_York'

  export default {
    name: 'CalendarConfiguration',
    components: {
      ConfigPublisher,
      FlipTime,
      Seasons,
    },
    data() {
      return {
        config: {},
        betaConfig: null,
        prodConfig: null,
        betaUrl: null,
        prodUrl: null,
        configName: "scoreboardflip",
        scoreboardHasErrors: false,
        validated: true,
      }
    },
    computed: {
      ...mapGetters([
        'betaEnvName',
        'liveEnvName',
        'isAdmin',
        'canScoreboardFlipEdit',
        'canScoreboardFlipPublish',
      ]),
      currentSeasonState() {
        return (this.config && this.config.currentSeasonId && this.config.currentSeasonId.length > 0)
      },
    },
    methods: {
      isValid() {
        let allValid = this.config.currentSeasonId.length > 0
        this.config.supportedSeasons.forEach((it, idx) => {
          const form = this.$refs.form[idx]
          if (!form.isValid()) {
            allValid = false
          }
        })
        return allValid
      },
      newConfig() {
        return {
          scoreboard: {
            flipTime: null,
            flipTimeZone: DEFAULT_TIMEZONE,
            nextDatePresented: null,
            skipToNextDayAfter: null,
          },
          currentSeasonId: "",
          supportedSeasons: [],
        }
      },
      handleScoreboardErrors(newVal) {
        this.scoreboardHasErrors = newVal
      },
      onSeasonUpdate(season) {
        season.seasonStartDate = season.preSeasonStartDate
        season.seasonEndDate = season.postSeasonEndDate
        if (!season.showSpringTraining) {
          season.seasonStartDate = season.regularSeasonStartDate
        }
        if (!season.showPostSeason) {
          season.seasonEndDate = season.regularSeasonEndDate
        }
      },
      onAddSeasonRange() {
        this.config.supportedSeasons.push({
          hasWildCard: true,
          postSeasonEndDate: "",
          postSeasonStartDate: "",
          preSeasonEndDate: "",
          preSeasonStartDate: "",
          regularSeasonEndDate: "",
          regularSeasonStartDate: "",
          seasonEndDate: "",
          seasonId: "",
          seasonStartDate: "",
          showPostSeason: true,
          showSpringTraining: true,
        })
      },
      validateSeasonRange(season) {
        return season.seasonStartDate !== null && season.seasonStartDate.length > 0
          && season.seasonEndDate !== null && season.seasonEndDate.length > 0
          && season.preSeasonStartDate !== null && season.preSeasonStartDate.length > 0
          && season.preSeasonEndDate !== null && season.preSeasonEndDate.length > 0
          && season.regularSeasonStartDate !== null && season.regularSeasonStartDate.length > 0
          && season.regularSeasonEndDate !== null && season.regularSeasonEndDate.length > 0
          && season.postSeasonStartDate !== null && season.postSeasonStartDate.length > 0
          && season.postSeasonEndDate !== null && season.postSeasonEndDate.length > 0
          && season.seasonId !== null && season.seasonId.length > 0
          && season.hasWildCard !== null && season.showPostSeason !== null
          && season.showSpringTraining !== null
      },
      async onRemoveSeasonRange(index) {
        // Only prompt to delete if the range has been populated
        if (this.config.supportedSeasons.length >= index && this.validateSeasonRange(this.config.supportedSeasons[index])) {
          const modalConfirmed = await this.$confirm.open(`Are you sure you wish to delete this season range?`)
          if (!modalConfirmed) {
            return
          }
        }
        this.config.supportedSeasons.splice(index, 1)
      },
    },
    async beforeRouteLeave(to, from, next) {
      if (this.$refs.configPublisher.configHasChanged()) {
        const message = `You have unpublished changes to your config, which will be lost.\n\nClick "Cancel" to go back and publish your work, or click "Yes" to lose your changes.`
        next(await this.$confirm.open(message))
      } else {
        next()
      }
    },
  }
</script>

<style scoped>

</style>
